export default __webpack_public_path__ + "static/media/eye.7e530d12.svg";